(function() {
    var SHOP_URL = '/collections/all';
    var LINK_CLASS = 'sn-start-shopping-link';

    function inject(container) {
    if (container.querySelector('.' + LINK_CLASS)) return;
    if (container.querySelector('.swym-storefront-layout-empty-state-cta-button')) return;
    if (container.querySelector('.swym-storefront-layout-empty-state-start-browsing')) return;
    if (container.querySelector('.swym-storefront-layout-empty-state-browse-cta')) return;
    if (container.querySelector('.swym-storefront-layout-empty-sfl-go-to-cart')) return;

    var a = document.createElement('a');
    a.href = SHOP_URL;
    a.className = LINK_CLASS;
    a.textContent = 'Start Shopping';
    container.appendChild(a);
    }

    function scan() {
    document.querySelectorAll('.swym-storefront-layout-empty-wishlist-content').forEach(inject);
    }

    var observer = new MutationObserver(scan);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    if (document.readyState !== 'loading') scan();
    else document.addEventListener('DOMContentLoaded', scan);
})();